export default __webpack_public_path__ + "static/installation1-db9557ed587e79a24fed12d61325fc5f.gif";